<template>
    <div class="trims-list">
        <div v-if="isLoading" class="w-100">
            <trim-card-loader />
        </div>
        <trim-card
            v-for="(trim, key) in trims"
            v-else
            :key="trim.id"
            :trim="trim"
            :base-trim="previousTrim(key)"
            :active="isActive(trim)"
            @select="onSelected(trim)"
            @compare="onCompare"
            @view-all-options="viewAllOptions"
        />
    </div>
</template>

<style lang="scss">
.trims-list {
    .compare-btn {
        font-family: $helvetica-56-italic;
        font-style: italic;
        font-size: 10px;
        color: $primary-blue;
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>

<script>
import TrimCard from "./TrimCard";
import { sync, get } from "vuex-pathify";
import _ from "lodash";
import TrimCardLoader from "Modules/ShopBy/Make/components/TrimCardLoader";

export default {
    components: { TrimCardLoader, TrimCard },

    props: {
        trims: {
            type: Array,
            required: true
        },
        value: {
            type: Object,
            required: false,
            default: null
        }
    },

    computed: {
        compareSelectedTrims: sync("shopBy/compareSelectedTrims"),
        isLoading: get("shopBy/loading"),
        baseTrim() {
            return _.head(this.trims);
        }
    },

    watch: {
        baseTrim(newVal) {
            if (!_.isNil(newVal) && _.isNil(this.value)) {
                this.onSelected(newVal);
            }
        }
    },

    methods: {
        onSelected(trim) {
            this.$emit("input", trim);
        },

        isActive(trim) {
            return trim.id === _.get(this.value, "id");
        },

        onCompare(checked, trim) {
            if (checked) {
                this.compareSelectedTrims = _.concat(
                    this.compareSelectedTrims,
                    trim
                );
            } else {
                this.compareSelectedTrims = _.filter(
                    this.compareSelectedTrims,
                    selectedTrim => {
                        return selectedTrim.id !== trim.id;
                    }
                );
            }
        },

        compareBtnClick() {
            this.$emit("compare-clicked");
        },

        previousTrim(currentKey) {
            if (currentKey === 0) {
                return null;
            }

            return this.trims[currentKey - 1];
        },

        viewAllOptions() {
            this.$emit("view-all-options");
        }
    }
};
</script>
